class Alert {
    constructor(
        {
            exibir = false,
            variant = null,
            mensagens = [],

            
        } = {}
    ) {
        this.exibir = exibir; 
        this.variant = variant; 
        this.mensagens = mensagens;    
    }
}

export default Alert;